module.exports = __webpack_public_path__ + "static/media/400038_01.8fac433d.png";